import "../css/style.scss";
import Headroom from "headroom.js";
import InfiniteScroll from "infinite-scroll";

/* ---------------------------------------------------------------- Scroll To */

function scrollTo(element) {
  window.scroll({
    behavior: "smooth",
    left: 0,
    top: element.offsetTop,
  });
}

/* ---------------------------------------------------------------- Accordion */

function accordion() {
  if (document.querySelector(".js-accordion")) {
    // Accordion
    var accordion = document.querySelector(".js-accordion");
    var accordionItem = accordion.querySelectorAll(".c-accordion__header");

    // check if URL already has a hash
    var hash = window.location.hash ? window.location.hash.substring(1) : null;

    if (hash) {
      openItem(hash, true);
      scrollTo(document.getElementById(hash));
    }

    window.addEventListener("popstate", function () {
      var h = window.location.hash ? window.location.hash.substring(1) : null;
      if (h && document.getElementById(h)) {
        openItem(h, true);
      }
    }, false);

    for (var i = 0, len = accordionItem.length; i < len; i++) {
      accordionItem[i].addEventListener("click", toggleAccordion);
    }

    function openItem(id, shouldOpen) {
      var item = document.getElementById(id);
      if (!item) return;

      var button = item.querySelector("button");
      if (!button) return;

      var isOpen = item.classList.contains("is-open");
      var nextState =
        typeof shouldOpen === "boolean" ? shouldOpen : !isOpen;

      item.classList.toggle("is-open", nextState);
      button.setAttribute("aria-expanded", nextState ? "true" : "false");
    }

    function toggleAccordion(event) {
      // Prevent normal click
      event.preventDefault();
      // Get originator element
      var element = event.target;
      var container = element.closest(".c-accordion__item");
      var elementId = container.id;
      var headlineEl = container.querySelector(".c-accordion__headline");
      var elementTitle = headlineEl ? headlineEl.textContent.trim() : "";

      openItem(elementId);

      history.pushState(
        {
          id: "why",
        },
        elementTitle,
        "#" + elementId
      );
    }
  }
}

/* ------------------------------------------------------------ Search toggle */

function searchToggle() {
  var searchOpen = document.querySelector(".js-search__open");
  var searchClose = document.querySelector(".js-search__close");
  var searchField = document.querySelector(".js-search__field");

  if (!searchOpen || !searchClose || !searchField) return;

  var html = document.getElementsByTagName("html")[0];

  searchOpen.addEventListener(
    "click",
    function () {
      html.classList.add("has-searchpanel-open");
      searchField.focus();
    },
    false
  );

  searchClose.addEventListener(
    "click",
    function () {
      html.classList.remove("has-searchpanel-open");
    },
    false
  );

  document.addEventListener("keydown", function (evt) {
    if (evt.key === "Escape") {
      html.classList.remove("has-searchpanel-open");
    }
  });
}

/* -------------------------------------------------------------Javascript check */

function checkJavascriptEnabled() {
  document.documentElement.className =
    document.documentElement.className.replace(/\bno-js\b/g, "") + " js ";
}

/* ------------------------------------------------------------- Text clipper */

function textClipper() {
  var clipperButton = document.querySelector(".js-clipper");

  if (clipperButton) {
    clipperButton.addEventListener(
      "click",
      function () {
        var clipperContainer = this.closest(".c-clipper");
        clipperContainer.classList.toggle("is-expanded");
      },
      false
    );
  }
}

/* ----------------------------------------------------------- Project filter */

var projectFilter = function () {
  if (document.getElementById("project-filters")) {
    // Show an element
    var show = function (elem) {
      elem.classList.remove("is-hidden");
    };

    // Hide an element
    var hide = function (elem) {
      elem.classList.add("is-hidden");
    };

    // Toggle element visibility
    var toggle = function (elem) {
      elem.classList.toggle("is-hidden");
    };

    // Get input element
    var projectFilters = document.getElementById("project-filters");

    if (projectFilters) {
      var projectFilter = projectFilters.querySelectorAll("[data-filter]");

      for (var i = 0, len = projectFilter.length; i < len; i++) {
        projectFilter[i].addEventListener("click", filterProjects);
      }

      function filterProjects(event) {
        // Get originator element
        var element = event.currentTarget;
        // Remove current is-active and aria-pressed from all filter buttons
        var currentIsActive = document.querySelector("#project-filters .is-active");
        currentIsActive.classList.remove("is-active");
        currentIsActive.setAttribute("aria-pressed", "false");
        // Make this element selected
        element.classList.add("is-active");
        element.setAttribute("aria-pressed", "true");
        // Get category to show
        var category = element.getAttribute("data-filter");
        // Get projects container ul
        var projectsContainer = document.getElementById("projects");
        // Get projects
        var projects = projectsContainer.querySelectorAll("li.project");
        // Get projects of current category
        var projectsFromCategory = projectsContainer.querySelectorAll(
          ".project.project-" + category
        );

        if (category !== "all") {
          // Hide all projects
          for (var i = 0, len = projects.length; i < len; i++) {
            hide(projects[i]);
          }
          // Show only projects of selected category
          for (var i = 0, len = projectsFromCategory.length; i < len; i++) {
            show(projectsFromCategory[i]);
          }
        } else {
          // Show all projects
          for (var i = 0, len = projects.length; i < len; i++) {
            show(projects[i]);
          }
        }
      }
    }
  }
};

/* ---------------------------------------------------------- Infinite Scroll */

function infinite() {
  "use strict";

  if (document.querySelector(".js-loadmore")) {
    var button = document.querySelector(".js-loadmore");
    var buttonLabel = button.textContent.trim();

    var elem = document.querySelector(".c-list");
    var infScroll = new InfiniteScroll(elem, {
      path: ".js-loadmore",
      append: ".c-list__item",
      //history: 'replace',
      history: "push",
      button: ".js-loadmore",
      scrollThreshold: false,
      fetchOptions: {
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      }
    });

    infScroll.on("request", function () {
      button.innerHTML = "Loading…";
    });

    infScroll.on("load", function () {
      button.innerHTML = buttonLabel;
    });
  }
}

/*--------------------------------------------------------------- Copy link */

function copyLink() {
  var buttons = document.querySelectorAll('.js-copy-link');
  if (!buttons.length) return;

  buttons.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var url = btn.dataset.url || window.location.href;
      navigator.clipboard.writeText(url).then(function () {
        btn.classList.add('is-copied');
        setTimeout(function () { btn.classList.remove('is-copied'); }, 2000);
      });
    });
  });
}

/*------------------------------------------------------------------ Validate */

function validate() {
  var inputs = document.querySelectorAll("input, textarea");
  for (var i = 0; i < inputs.length; i++) {
    inputs[i].addEventListener("change", function () {
      if (!this.checkValidity()) {
        this.closest("div").classList.add("has-error");
      } else {
        this.closest("div").classList.remove("has-error");
      }
    });
  }
}

/*
 * Mailchimp AJAX form submit VanillaJS
 * Vanilla JS
 * Author: Michiel Vandewalle
 * Github author: https://github.com/michiel-vandewalle
 * Github project: https://github.com/michiel-vandewalle/Mailchimp-AJAX-form-submit-vanillaJS
 */

function subscribe() {
  if (document.getElementById("mc-embedded-subscribe-form")) {
    document
      .getElementById("mc-embedded-subscribe-form")
      .addEventListener("submit", function (e) {
        e.preventDefault();

        var formInputs = document.getElementById("js-form-inputs");
        var formReponse = document.getElementById("js-subscribe-response");

        if (e.target.checkValidity() == true) {
          if (document.getElementById("js-validate-robot").value !== "") {
            return false;
          }

          var url = this.action.replace("/post?", "/post-json?");

          var data = "";
          var inputs = this.querySelectorAll(
            '#js-form-inputs input:not([type="radio"]), #js-form-inputs input[type="radio"]:checked'
          );
          for (var i = 0; i < inputs.length; i++) {
            data +=
              "&" + inputs[i].name + "=" + encodeURIComponent(inputs[i].value);
          }

          var script = document.createElement("script");
          script.src = url + data;
          document.body.appendChild(script);

          var callback = "callback";
          window[callback] = function (data) {
            delete window[callback];
            document.body.removeChild(script);

            if (data.status === "subscribed") {
              formReponse.textContent = "You are already subscribed to this mailing list.";
              formReponse.classList.remove("is-hidden");
            } else {
              formInputs.classList.add("is-hidden");
              formReponse.textContent = data.msg;
              formReponse.classList.remove("is-hidden");
            }
          };
        } else {
          var inputs = document.querySelectorAll("input, textarea");
          for (var i = 0; i < inputs.length; i++) {
            var wrapper = inputs[i].closest(".c-form__item");
            if (wrapper) {
              if (!inputs[i].checkValidity()) {
                wrapper.classList.add("has-error");
              } else {
                wrapper.classList.remove("has-error");
              }
            }
          }
        }
      });
  }
}

/*------------------------------------------------------------------ Headroom */

function headroom() {
  var myElement = document.querySelector(".c-masthead");
  if (!myElement) return;
  var headroom = new Headroom(myElement, {
    tolerance: {
      down: 10,
      up: 0,
    },
    offset: 182,
  });
  headroom.init();
}

/*---------------------------------------------------------------------- Init */
var init = function () {
  checkJavascriptEnabled();
  validate();
  subscribe();
  searchToggle();
  accordion();
  projectFilter();
  infinite();
  textClipper();
  copyLink();
  headroom();
};

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", init); // Document still loading so DomContentLoaded can still fire :)
} else {
  init();
}
